module.exports = __webpack_public_path__ + "static/img/icon1.1bb5832c.png";